module.exports = ".base-form-width{\r\n    width:300px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/a0103-question-register/question-register.component.css
// module id = ./src/app/a0103-question-register/question-register.component.css
// module chunks = main